// Reusable Edge reveal model: turns a graded tap task into what the learner got
// right and what needs correcting. It is driven entirely by data — the element,
// the learner's actual tap and the element's true position — and knows nothing
// about candles. Each Read supplies two functions:
//
//   anchorOf(promptId)  -> the true position of that element, in data units
//   describe(point)     -> { short, long } plain-language name of a position
//                          ("Top of body" / "the top of the body")
//
// Every marker the reveal draws comes from these values; nothing is placed by
// eye. A later Read (swing highs, support/resistance) passes its own anchorOf
// and describe and reuses the reveal screens unchanged.
export function buildReveal(prompts, results, { anchorOf, describe }) {
  const correct = [];
  const mistakes = [];
  prompts.forEach((p) => {
    const r = results.byId[p.id];
    if (r.correct) {
      correct.push({ id: p.id, label: p.label, tap: r.answer });
      return;
    }
    const anchor = anchorOf(p.id);
    mistakes.push({
      id: p.id,
      label: p.label,
      tap: r.answer,
      anchor,
      yourPlace: describe(r.answer),
      correctPlace: describe(anchor),
    });
  });
  return { correct, mistakes, total: prompts.length };
}
